import { useState, useCallback } from 'react';
import { useSpinner, useToast } from '@chikara/ui';
import { cardService } from '@/features/card/services/cardService/cardService';
import type { UseActivateCardReturn, AccountCreateRequest } from '@/features/card/types/card.types';
import { t } from '@/i18n';

export const useActivateCard = (): UseActivateCardReturn => {
  const { show, hide } = useSpinner();
  const { success } = useToast();
  const [error, setError] = useState<string | null>(null);

  const accountCreate = useCallback(
    async (payload: AccountCreateRequest) => {
      show();
      setError(null);
      try {
        await cardService.accountCreate(payload);
        success(
          t(
            `dashboard.card.activateModal.result.${payload.assigned_limit ? 'success' : 'successPending'}`
          )
        );
        return true;
      } catch (err) {
        setError(
          t(
            `dashboard.card.activateModal.result.${payload.assigned_limit ? 'error' : 'errorPending'}`
          )
        );
        return false;
      } finally {
        hide();
      }
    },
    [show, hide, success]
  );

  const cardActivate = useCallback(
    async (payload: any) => {
      show();
      setError(null);
      try {
        await cardService.cardActivate(payload);
        success(t('dashboard.card.activateModal.result.success'));
        return true;
      } catch (err) {
        setError(t('dashboard.card.activateModal.result.error'));
        return false;
      } finally {
        hide();
      }
    },
    [show, hide, success]
  );

  return { accountCreate, cardActivate, error };
};
